import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/disciplinary-letters', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/disciplinary-letters', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = data => {
  return httpClient
    .post('/api/disciplinary-letters/delete-records', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getData = (options = {}) => {
  return httpClient
    .get('/api/disciplinary-letters/get-data', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printPDF = (Options = {}) => {
  return httpClient
    .get('/api/disciplinary-letters/preview-pdf', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  destroy,
  getData,
  printPDF
}
